var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',[_c('h1',[_vm._v("欢迎进入德鲁克贸易河北有限公司后台管理系统")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }